// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Conversație',
  working: 'Lucrez la asta…',
  stopped: 'Oprit. Nimic nu s-a schimbat.',
  step_stopped: 'Oprit',
  not_sent: 'Netrimis',
  failed: {
    text: 'Ceva nu a mers bine din partea mea, așa că nimic nu s-a schimbat. Încearcă din nou peste un moment.',
    retry: 'Încearcă din nou',
  },
  question: {
    type_answer: 'Sau scrie răspunsul mai jos.',
  },
  unavailable: {
    title: {
      amigo: 'Amigo nu este disponibil momentan.',
      assistant: 'Asistentul nu este disponibil momentan.',
    },
    text: 'Nimic nu s-a schimbat, iar restul panoului funcționează normal. Încearcă din nou în câteva minute.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Azi',
  when: {
    today: 'Azi, {{time}}',
    yesterday: 'Ieri, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line:
    'Conversație nouă pentru {{restaurant}}. Conversațiile lui {{previous}} se află la Conversații când te întorci la el.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: 'Chatul lui {{name}} (FoodAmigos)',
      owner: 'Chatul lui {{name}} (proprietar)',
      staff: 'Chatul lui {{name}} (personal)',
      partner: 'Chatul lui {{name}} (partener)',
      other: 'Chatul lui {{name}}',
      unnamed: 'Chatul altcuiva',
    },
    text: 'Conversația lui {{name}}. O poți citi, dar nu poți răspunde și nici aproba cardurile ei.',
    text_unnamed: 'Chatul altcuiva. Îl poți citi, dar nu poți răspunde și nici aproba cardurile lui.',
    new_chat: 'Conversație nouă',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Această conversație s-a încheiat. Începe o conversație nouă pentru a continua.',
    new_chat: 'Conversație nouă',
    moved_line: 'Chat nou, deoarece cel anterior se încheiase',
  },
  composer: {
    label: 'Mesaj',
    placeholder: 'Pune o întrebare sau descrie o modificare',
    placeholder_answer: 'Introduceți răspunsul',
    hint: 'Enter pentru a trimite · Shift+Enter rând nou',
  },
  table: {
    show_all: 'Afișează toate cele {{count}} rânduri',
    show_fewer: 'Afișează mai puține',
  },
  steps: {
    areas: 'Verific cu ce te pot ajuta aici',
    area_describe: 'Mă uit la {{area}}',
    read: 'Citesc datele tale',
    propose: 'Pregătesc modificarea',
    change_set_get: 'Verific modificarea',
    gap_record: 'Notez asta pentru echipa noastră',
    research: 'Caut cum funcționează',
    screen_find: 'Caut pagina potrivită',
    file_read: 'Citesc fișierul tău',
    shop_check: 'Verific magazinul tău',
    area_describe_other: 'Mă uit la această zonă',
    other: 'Verific ceva',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    read: {
      menu: 'Meniul nu a putut fi citit',
      hours: 'Programul de funcționare nu a putut fi citit',
      order_settings: 'Setările comenzilor nu au putut fi citite',
      my_info: 'Datele tale nu au putut fi citite',
      marketing: 'Marketingul tău nu a putut fi citit',
      gift_cards: 'Cardurile cadou nu au putut fi citite',
      reports: 'Cifrele tale nu au putut fi citite',
      other: 'Datele tale nu au putut fi citite',
    },
    propose: {
      menu: 'Modificarea meniului nu a putut fi pregătită',
      hours: 'Modificarea programului de funcționare nu a putut fi pregătită',
      order_settings: 'Modificarea setărilor comenzilor nu a putut fi pregătită',
      my_info: 'Modificarea datelor tale nu a putut fi pregătită',
      marketing: 'Modificarea de marketing nu a putut fi pregătită',
      gift_cards: 'Modificarea cardurilor cadou nu a putut fi pregătită',
      other: 'Modificarea nu a putut fi pregătită',
    },
    change_set_get: { other: 'Modificarea nu a putut fi verificată' },
    research: { other: 'Nu am putut afla cum funcționează aceasta' },
    screen_find: { other: 'Pagina nu a putut fi găsită' },
    file_read: { other: 'Fișierul tău nu a putut fi citit' },
    shop_check: { other: 'Magazinul tău nu a putut fi deschis' },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'meniul',
    hours: 'programul de funcționare',
    order_settings: 'setările comenzilor',
    my_info: 'informațiile restaurantului tău',
    marketing: 'marketing',
    reports: 'rapoartele',
  },
};
